import * as React from "react";
import Dreams from "../Dreams";

export function NoDreamsZenIcon({ dreams }: { dreams: Dreams }) {
    if (dreams.state.filteredData.length > 0) {
        return null;
    }

    return <div style={{ width: `100%`, fontSize: `36px` }}>☯</div>;
}
